import moment from 'moment';

import { apiGateway } from '../api';

async function trocarPlano(body) {
    try {
        body.tipoOperacao = 'TrocaDePlano';

        const response = await apiGateway.post('/titular/trocarPlano', body);

        return response.data;
    } catch (error) {
        return error.data;
    }
}

async function alterarBeneficiario(body) {
    try {
        body.tipoOperacao = 'AlteracaoCadastral';
        body.possuiPortabilidade = false;
        body.enderecoResidencial = true;
        body.excluirEndereco = false;
        body.exerceuPortabilidadeOrigem = false;
        body.viveNoExterior = false;
        body.enderecoDeCobranca = false;
        body.enderecoDeCorrespondencia = false;
        body.carenciaParcialTemporariaOrigem = false;

        const response = await apiGateway.post('/alterar/beneficiario', body);

        return response.data;
    } catch (error) {
        const errorData = error.response.data ? error.response.data[0] : false;
        return errorData;
    }
}

async function desligarBeneficiario(body) {
    try {
        body.tipoOperacao = 'Exclusao';
        body.contrinutario = false;
        body.emiteComprovante = true;
        body.valorMulta = 0;
        body.movimentaDental = false;

        const response = await apiGateway.post('/beneficiario/desligar', body);

        return response.data;
    } catch (error) {
        return error;
    }
}

async function inativar(body) {
    try {
        body.tipoOperacao = 'AposentadosDemitidos';

        const response = await apiGateway.post('/inativar/beneficiario', body);
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function adicionarTitular(body) {
    try {
        body.tipoOperacao = 'InclusaoTitular';
        body.carenciaParcialTemporariaOrigem = false;
        body.enderecoDeCobranca = false;
        body.enderecoDeCorrespondencia = false;
        body.excluirEndereco = false;
        body.exerceuPortabilidadeOrigem = false;
        body.viveNoExterior = false;
        body.enderecoResidencial = true;
        body.possuiPortabilidade = false;

        const response = await apiGateway.post('/adicionar/beneficiario', body);

        return response.data;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function adicionarDependente(body) {
    try {
        body.tipoOperacao = 'InclusaoDependente';

        const response = await apiGateway.post('/dependente/adicionar', body);

        return response.data;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function transferirBeneficiario(body) {
    try {
        body.tipoOperacao = 'TransferenciaDeContrato';

        const response = await apiGateway.post('/beneficiario/transferir', body);

        return response.data;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function buscarPendentes(param) {
    try {
        const response = await apiGateway.get(`/movimentacoes/pendentes/${param}`);

        return response.data.results;
    } catch (error) {
        return false;
    }
}

async function movimentacoesPendentes(query) {
    try {
        const params = new URLSearchParams();
        params.append('numContrato', query.numContrato);
        params.append('offset', query.offset);
        params.append('limit', query.limit);

        if (query.dtInicioPeriodo) params.append('dtInicioPeriodo', moment(query.dtInicioPeriodo).format('DD/MM/YYYY'));
        if (query.dtFimPeriodo) params.append('dtFimPeriodo', moment(query.dtFimPeriodo).format('DD/MM/YYYY'));
        if (query.nomeCarteira) params.append('nomeCarteira', query.nomeCarteira);
        if (query.protocolo) params.append('protocolo', query.protocolo);
        if (query.operacao) params.append('operacao', query.operacao);
        if (query.status) params.append('status', query.status);

        const response = await apiGateway.get('/movimentacoes/pendentes', {
            params,
        });

        return response.data;
    } catch (error) {
        return false;
    }
}

async function reativarBeneficiario(body) {
    try {
        body.tipoOperacao = 'Reativacao';

        const response = await apiGateway.post('/beneficiario/reativar', body);

        return response.data;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function getHistoricoMovimentacoes(queryParams) {
    try {
        const response = await apiGateway.get(`/movimentacoes/historico`, { params: queryParams });
        return response.data;
    } catch (error) {
        return error;
    }
}

export {
    trocarPlano,
    alterarBeneficiario,
    desligarBeneficiario,
    adicionarTitular,
    adicionarDependente,
    transferirBeneficiario,
    buscarPendentes,
    inativar,
    movimentacoesPendentes,
    reativarBeneficiario,
    getHistoricoMovimentacoes,
};
